import { spacing } from "app/shared/styles/spacing";
import { pushAppFlyer } from "app/shared/util/app-flyer";
import * as React from "react";
import { Linking, Pressable, StyleProp, useWindowDimensions, View, ViewStyle } from "react-native";
import { useTheme } from "react-native-paper";
import Animated, { Extrapolate, interpolate, useAnimatedStyle, useSharedValue } from "react-native-reanimated";
import Carousel from "react-native-reanimated-carousel";
import { CarouselRenderItemInfo, ICarouselInstance } from "react-native-reanimated-carousel/lib/typescript/types";
import { CreateResponsiveStyle, DEVICE_SIZES, maxSize } from "rn-responsive-styles";
import { Block } from "../../blocks/block";

interface ItemLink {
  uri_mb: string;
  uri_ib: string;
  name: string;
  link: string;
}

const items: ItemLink[] = [
  {
    uri_mb: require("@assets/images/banner/mobile/mb-banner-home-6.jpg"),
    uri_ib: require("@assets/images/banner/banner-home-6.jpg"),
    name: "Mở đặc quyền, kiến tạo vị thế",
    link: "https://www.pvcombank.com.vn/khuyen-mai/uu-dai-khac/chi-tiet/nhan-toi-13500-dam-thuong-bong-sen-vang-khi-chi-tieu-qua-the-tin-dung-pvcombank?utm_source=IB_KHCN&utm_medium=Timhieuthem&utm_campaign=&utm_content=",
  },
  {
    uri_mb: require("@assets/images/banner/mobile/mb-banner-home-2.jpg"),
    uri_ib: require("@assets/images/banner/banner-home-2.jpg"),
    name: "Sản phẩm vay",
    link: "https://www.pvcombank.com.vn/danh-muc-san-pham/ca-nhan/san-pham-vay",
  },
  {
    uri_mb: require("@assets/images/banner/mobile/mb-banner-home-1.jpg"),
    uri_ib: require("@assets/images/banner/banner-home-1.jpg"),
    name: "Tích điểm thật nhanh - Đổi quà thật chất",
    link: "https://www.pvcombank.com.vn/khuyen-mai/uu-dai-khac/chi-tiet/pvone-1-cho-tat-ca?utm_source=IB_KHCN&utm_medium=bannerhome&utm_campaign=MKT_PVOneTh12",
  },
  {
    uri_mb: require("@assets/images/banner/mobile/mb-banner-home-7.jpg"),
    uri_ib: require("@assets/images/banner/banner-home-7.jpg"),
    name: "Ưu đãi mở thẻ tín dụng",
    link: "https://www.pvcombank.com.vn/khuyen-mai/uu-dai-khac/chi-tiet/tan-huong-uu-dai-len-toi-1-ty-dong-tu-the-tin-dung-pvcombank-mastercard?utm_source=IB_KHCN&utm_medium=bannerhome&utm_campaign=MKT_chonthebanyeu&utm_content=",
  },
  {
    uri_mb: require("@assets/images/banner/mobile/mb-banner-home-3.jpg"),
    uri_ib: require("@assets/images/banner/banner-home-3.jpg"),
    name: "Thanh toán tự động",
    link: "https://pvcombank.com.vn/san-pham/ca-nhan/ngan-hang-so/pvauto?utm_source=IB_KHCN&utm_medium=bannerhome&utm_campaign=MKT_thanhtoantudong",
  },
  {
    uri_mb: require("@assets/images/banner/mobile/mb-banner-home-4.jpg"),
    uri_ib: require("@assets/images/banner/banner-home-4.jpg"),
    name: "Ưu đãi trả góp qua thẻ tín dụng",
    link: "https://pvcombank.com.vn/khuyen-mai/uu-dai-khac/chi-tiet/uu-dai-tra-gop-lai-suat-0-qua-the-tin-dung-pvcombank?utm_source=IB_KHCN&utm_medium=bannerhome&utm_campaign=MKT_Tragop",
  },
];

export const PaginationItem: React.FC<{
  index: number;
  backgroundColor: string;
  length: number;
  animValue: Animated.SharedValue<number>;
  isRotate?: boolean;
}> = (props) => {
  const { animValue, index, length, backgroundColor, isRotate } = props;
  const { colors } = useTheme();

  const width = 8;

  const animStyle = useAnimatedStyle(() => {
    let inputRange = [index - 1, index, index + 1];
    let outputRange = [-width, 0, width];

    if (index === 0 && animValue?.value > length - 1) {
      inputRange = [length - 1, length, length + 1];
      outputRange = [-width, 0, width];
    }

    return {
      borderRadius: 4,
      backgroundColor,
      flex: 1,
      transform: [
        {
          translateX: interpolate(animValue?.value, inputRange, outputRange, Extrapolate.CLAMP),
        },
      ],
    };
  }, [animValue, index, length]);

  const animPagnigationStyle: StyleProp<ViewStyle> = {
    backgroundColor: colors.backgroundForm,
    width,
    height: width,
    borderRadius: 4,
    marginVertical: spacing.small,
    marginHorizontal: 4,
    overflow: "hidden",
    transform: [
      {
        rotateZ: isRotate ? "90deg" : "0deg",
      },
    ],
  };

  return (
    <View style={animPagnigationStyle}>
      <Animated.View style={animStyle} />
    </View>
  );
};

const CustomCauroselMobile = () => {
  const { colors } = useTheme();
  const { width } = useWindowDimensions();

  const { styles } = useStyles();
  const r = React.useRef<ICarouselInstance>(null);
  const progressValue = useSharedValue<number>(0);
  const isSnap = React.useRef(false);

  const handlerParamsAppFlyer = (item: ItemLink, index: number) => {
    console.log("handlerParamsAppFlyer");
    const param = {
      // promotion_id, promotion_title, promotion_place, promotion_campaign, promotion_link
      promotion_link: item.link,
      promotion_place: String(index),
      promotion_campaign: item.name,
    };
    return {
      eventName: "af_click_promotion",
      params: {
        af_channel: "ib_rb",
        af_promotion_value: JSON.stringify(param),
      },
    };
  };

  React.useEffect(() => {
    console.log("CustomCauroselMobile");
    let autoPlay = setInterval(() => {
      r.current?.next();
    }, 7000);
    return () => {
      clearInterval(autoPlay);
    };
  }, []);

  const onPress = React.useCallback((index) => {
    if (r.current?.getCurrentIndex() === index && isSnap.current === false) {
      if (items[index].link.length) {
        const { eventName, params } = handlerParamsAppFlyer(items[index], index);
        pushAppFlyer(eventName, params);
        Linking.openURL(items[index].link);
      }
    }
  }, []);

  const renderItem = ({ item, index }: CarouselRenderItemInfo<any>) => {
    return (
      <Pressable onPress={() => onPress(index)}>
        <Animated.Image style={styles("imageMobileCauroselStyle")} source={item.uri_mb} />
      </Pressable>
    );
  };

  return (
    <>
      <Carousel
        width={width}
        height={(width * 900) / 1600}
        snapEnabled={false}
        style={styles("cauroselMobileStyle")}
        autoPlay={false}
        ref={r}
        onScrollBegin={() => {
          isSnap.current = true;
        }}
        panGestureHandlerProps={{
          activeOffsetX: [-10, 10],
        }}
        onScrollEnd={() => {
          isSnap.current = false;
        }}
        defaultIndex={0}
        data={items}
        onProgressChange={(_, absoluteProgress) => (progressValue.value = absoluteProgress)}
        renderItem={renderItem}
      />
      <Block row middle center>
        {items.map((_item, index) => (
          <PaginationItem key={index} backgroundColor={colors.accent} animValue={progressValue} index={index} length={items.length} />
        ))}
      </Block>
    </>
  );
};

const CustomCaurosel = () => {
  const { colors } = useTheme();

  const progressValue = useSharedValue<number>(0);
  const r = React.useRef<ICarouselInstance>(null);
  const isSnap = React.useRef(false);
  const { styles } = useStyles();

  const handlerParamsAppFlyer = (item: ItemLink, index: number) => {
    console.log("handlerParamsAppFlyer");
    const param = {
      // promotion_id, promotion_title, promotion_place, promotion_campaign, promotion_link
      promotion_link: item.link,
      promotion_place: String(index),
      promotion_campaign: item.name,
    };
    return {
      eventName: "af_click_promotion",
      params: {
        af_channel: "ib_rb",
        af_promotion_value: JSON.stringify(param),
      },
    };
  };

  React.useEffect(() => {
    console.log("CustomCaurosel");
    let autoPlay = setInterval(() => {
      r.current?.next();
    }, 7000);
    return () => {
      clearInterval(autoPlay);
    };
  }, []);

  const renderItem = ({ item, index, animationValue }: CarouselRenderItemInfo<any>) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const _anim: any = useAnimatedStyle(() => {
      const translateX = interpolate(animationValue.value, [-1, 0, 1], [300, 0, -300], Extrapolate.EXTEND);
      const scale = interpolate(animationValue.value, [-1, 0, 1], [0.9, 1, 0.9], Extrapolate.EXTEND);
      const opacity = interpolate(animationValue.value, [-1, 0, 1], [0.25, 1, 0.25], Extrapolate.EXTEND);
      const rotateY = `${interpolate(animationValue.value, [-1, 0, 1], [-45, 0, 45], Extrapolate.EXTEND)}deg`;
      return {
        opacity,
        transform: [{ translateX }, { perspective: 1200 }, { rotateY }, { scale }],
      };
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const onPress = React.useCallback(() => {
      if (r.current?.getCurrentIndex() === index && isSnap.current === false) {
        const { eventName, params } = handlerParamsAppFlyer(items[index], index);
        pushAppFlyer(eventName, params);
        if (items[index].link) Linking.openURL(items[index].link);
      }
      if (r.current?.getCurrentIndex() !== index && isSnap.current === false) {
        r.current?.scrollTo({
          animated: true,
          count: animationValue.value,
        });
      }
    }, [animationValue.value, index]);
    return (
      <Animated.View style={_anim}>
        <Pressable onPress={onPress}>
          <Animated.Image style={styles("imageCauroselStyle")} source={item.uri_ib} />
        </Pressable>
      </Animated.View>
    );
  };

  return (
    <>
      <Carousel
        width={(200 * 1600) / 571}
        height={200}
        ref={r}
        mode="parallax"
        style={styles("cauroselStyle")}
        modeConfig={{
          parallaxScrollingOffset: 0,
          parallaxScrollingScale: 1,
        }}
        autoPlay={false}
        panGestureHandlerProps={{
          activeOffsetX: [-10, 10],
        }}
        defaultIndex={0}
        scrollAnimationDuration={50}
        snapEnabled={false}
        onScrollBegin={() => {
          isSnap.current = true;
        }}
        onScrollEnd={() => {
          isSnap.current = false;
        }}
        data={items}
        onProgressChange={(_, absoluteProgress) => (progressValue.value = absoluteProgress)}
        renderItem={renderItem}
      />
      <Block row middle center>
        {items.map((_item, index) => (
          <Pressable
            key={index}
            onPress={() => {
              r.current?.scrollTo({index: index, animated: true});
            }}>
            <PaginationItem backgroundColor={colors.accent} animValue={progressValue} index={index} length={items.length} />
          </Pressable>
        ))}
      </Block>
    </>
  );
};

const BannerAd = () => {
  const { styles } = useStyles();
  return (
    <View>
      <View style={styles("containerMobile")}>
        <CustomCauroselMobile />
      </View>
      <View style={styles("containerTablet")}>
        <CustomCaurosel />
      </View>
      <View style={styles("containerDesktop")}>
        <CustomCaurosel />
      </View>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    containerDesktop: {
      display: "flex",
    },
    containerTablet: {
      display: "none",
    },
    containerMobile: {
      display: "none",
    },
    cauroselStyle: {
      width: "100%",
      justifyContent: "center",
    },
    cauroselMobileStyle: {
      width: "100%",
      justifyContent: "center",
    },
    imageCauroselStyle: {
      width: undefined,
      height: 200,
      borderRadius: 24,
      aspectRatio: 1600 / 571,
    },
    imageMobileCauroselStyle: {
      width: undefined,
      height: 200,
      borderRadius: 24,
      aspectRatio: 1600 / 900,
    },
  },
  {
    [DEVICE_SIZES.EXTRA_LARGE_DEVICE]: {
      containerDesktop: {
        display: "flex",
      },
      containerTablet: {
        display: "none",
      },
      containerMobile: {
        display: "none",
      },
    },
    [maxSize(DEVICE_SIZES.LARGE_DEVICE)]: {
      containerDesktop: {
        display: "none",
      },
      containerTablet: {
        display: "flex",
      },
      containerMobile: {
        display: "none",
      },
    },
    [DEVICE_SIZES.EXTRA_SMALL_DEVICE]: {
      containerDesktop: {
        display: "none",
      },
      containerTablet: {
        display: "none",
      },
      containerMobile: {
        display: "flex",
      },
      cauroselStyle: {
        width: "100%",
        height: undefined,
        aspectRatio: 1600 / 571,
        justifyContent: "center",
        alignItems: "center",
      },
      cauroselMobileStyle: {
        width: "100%",
        height: undefined,
        aspectRatio: 1600 / 900,
        justifyContent: "center",
        alignItems: "center",
      },
      imageCauroselStyle: {
        aspectRatio: 1600 / 571,
        width: "100%",
        borderRadius: 0,
        justifyContent: "center",
        alignItems: "center",
        height: undefined,
      },
      imageMobileCauroselStyle: {
        aspectRatio: 1600 / 900,
        width: "100%",
        borderRadius: 0,
        justifyContent: "center",
        alignItems: "center",
        height: undefined,
      },
    },
  },
);

export default BannerAd;
